<div class="qa-signature-options">
  <div class="qa-signature-type input-group">
    <span class="input-group-addon">{{_(KEYS.EDITOR.TYPE_OF_SIGNATURE)}}</span>
    <select class="form-control qa-custom-select" [(ngModel)]="question.displayType">
      <option value="canvas">myMedax</option>
      <option value="pdf">SignoSign</option>
    </select>
  </div>
  <div class="qa-signature-autounlock form-check mt-2" *ngIf="question.displayType === 'canvas'">
    <label class="form-check-label">
      <input class="form-check-input" type="checkbox" [(ngModel)]="question.options.autoUnlock" />
      {{_(KEYS.EDITOR.AUTO_UNLOCK)}}
    </label>
  </div>
</div>
